import { withCompInfo } from '@wix/editor-elements-integrations'
import { minimumLabelFontSize } from '../../core/carmi/InputUtils/constants'
import { ComboBoxInputCSSVars, ComboBoxInputDefinition } from './ComboBoxInput'
import { getScaledFont } from '@wix/thunderbolt-becky-root'
import { getCrossEditorsCssVars } from './common'
import { getInputHeightInPx, getLabelPaddingObject } from '../../core/mappers/inputUtils'
import { getHeightPixelValue } from '@wix/editor-elements-common-utils'

export const css = withCompInfo<ComboBoxInputCSSVars, ComboBoxInputDefinition>()(
	// @ts-ignore - remove once siteFonts is added to CompInfo
	[
		'compProps',
		'hasResponsiveLayout',
		'compLayout',
		'compSingleLayout',
		'styleProperties',
		'siteFonts',
		'isMobileView',
		// @ts-ignore - remove once isOneDocMigrated is added to CompInfo
		'isOneDocMigrated',
	],
	// @ts-ignore - remove once isOneDocMigrated is added to CompInfo
	({
		compProps,
		hasResponsiveLayout,
		compLayout,
		compSingleLayout,
		styleProperties,
		siteFonts,
		isMobileView,
		// @ts-ignore - remove once isOneDocMigrated is added to CompInfo
		isOneDocMigrated,
	}) => {
		const { textAlignment, labelMargin, labelMobileFontSize, inputHeight, inputHeightMobile } = compProps
		const compInfo = { compLayout, compProps, styleProperties, siteFonts, isMobileView }
		const sharedVars = {
			'--arrowLeftPosition': textAlignment === 'right' ? '0' : 'auto',
			'--arrowRightPosition': textAlignment === 'right' ? 'auto' : '0',
			'--labelMarginBottom': `${labelMargin}px`,
			'--fntlbl': getScaledFont(compInfo, 'fntlbl', isOneDocMigrated, labelMobileFontSize, minimumLabelFontSize),
			'--requiredIndicationDisplay':
				styleProperties.txtlblrq && styleProperties.txtlblrq !== 'transparent' ? 'inline' : 'none',
			...getCrossEditorsCssVars(compInfo, compProps, isOneDocMigrated),
			...getLabelPaddingObject(compProps),
		}
		const height = getHeightPixelValue(compLayout, compSingleLayout)
		return hasResponsiveLayout
			? sharedVars
			: {
					...sharedVars,
					height: 'auto',
					'--inputHeight': getInputHeightInPx({
						isMobileView,
						height,
						inputHeight: inputHeight!,
						inputHeightMobile: inputHeightMobile!,
					}),
			  }
	}
)
